import React from "react";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import Input from "../Input-new/Input";
import { formatNumber } from "../../utils";
import Textarea from "../Textarea-new/Textarea";
import { athcapBlueLogo, striveLogo } from "../../consts/consts";
import plus from "../../svgs/plus-white.svg";
import Icon from "../Icon/Icon";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import VerticalTableDragableCard from "./VerticalTableDragableCard";

const printRowsPerPage = 26;

export default class VerticalTable extends React.Component {
    dropdownIDs;
    inputIDs;
    textareaIDs;
    headingKeys;
    constructor(props) {
        super(props);

        this.state = {
            printHeadings:[],
            printTablesNumber: null,
            activeElementId: null,
            printBackground: '',
            isPrint: false,
            hscTeamMemberDetail: null,
            selectAllChecked: false,
        }

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
        
        this.tbodyRef = React.createRef();
        this.verticalTableRef = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.formatElement = this.formatElement.bind(this);
        this.handlePrintKeyClick = this.handlePrintKeyClick.bind(this);
        this.handlePrintPagesDropDown = this.handlePrintPagesDropDown.bind(this);
        this.onSelectAllChange = this.onSelectAllChange.bind(this);
        this.moveCard = this.moveCard.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this)
    }

    componentDidMount() {
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
        
        const printHeadings = this.props.hasPrint && this.props.headings.filter(el => el.isPrintable !== false);
        const printTablesNumber = Math.ceil(this.props.headings.length / printRowsPerPage);
        this.dropdownIDs=this.props.headings.filter(el=>el.format==='dropdown').map(el=>{return el.key});
        this.textareaIDs=this.props.headings.filter(el=>el.format==='textarea').map(el=>{return el.key});
        this.inputIDs=this.props.headings.filter(el=>el.format!=='dropdown' && el.format!=='textarea').map(el=>{return el.key});
        this.headingKeys = this.props.headings.map(el => {return el.key});
        
        this.setState({printBackground : 'linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%)', printHeadings, printTablesNumber});
    }

    handlePrintPagesDropDown(key, value){
        this.props.handlePrintPagesDropDown(key, value);
    }

    beforePrint() {
        this.setState({isPrint:true})
    }

    afterPrint() {
        this.setState({isPrint:false})    
    }
    
    handleChange(key, value){
        this.props.handleChangeInput(key,value);
    }

    handleChangeDropdown(query, queryType, x, key) {
        this.props.handleChangeDropdown(query, queryType, x,key);
    }

    formatElement(elem, format, decimals) {
        switch(format){
            case '$': return elem ? '$'+formatNumber(elem,true): '';
            case '%': return elem ? (decimals ? Number(elem).toFixed(decimals)+'%' : Number(elem).toFixed(2)+'%'):'';
            case 'years': return elem ? elem + ' Years' : ''; 
            default: return elem;
        }
    }
    onSelectAllChange(event) {
        const isChecked = event.target.checked;
        this.setState({ selectAllChecked: isChecked });

        const updatedColumns = this.props.columns.map((item) => ({
        ...item,
        is_printable: isChecked,
        }));
        this.setState({ columns: updatedColumns });
        this.props.updateColumns(updatedColumns);
    }
    handleCheckboxChange(event, index){
        const isChecked = event.target.checked;
        const updatedColumns = [...this.props.columns];
        updatedColumns[index].is_printable = isChecked;

        this.props.updateColumns(updatedColumns); 
    }

    renderInputElement({column, heading, isEditable, columnIndex, isPrint,printTableColumns}) {
        const id = `${heading.key}-${columnIndex}`;
        /** Hide NOI related fields if the checbox at top is unchecked**/
        const hideAutoPopulateKey = ['noi', 'noi_percentage', 'noi_multiplied', 'purchase_price'].includes(heading.key) && (!column['is_printable']) && (+column['autopopulate']);
        switch (heading.format) {
            case 'dropdown':
                return <Dropdown
                    id={id}
                    theme='no-border'
                    viewClassName='vertical-table'
                    fillText={heading.dropdownType === 'loanquotes-amortization' ? ' Years' : ''}
                    optionsType={heading.dropdownType}
                    inputMode={true}
                    valueKey={id}
                    className='VerticalTable_input'
                    data={column}
                    value={column[heading.key]}
                    tooltip={heading.tooltip}
                    viewMode={!isEditable}
                    handleParentChange={this.handleChangeDropdown}
                    handleInputFocus = {()=>this.handleInputFocus(id)}
                    openOnFocus={true}
                />
                
            case 'textarea':
                return <Textarea
                    id={id}
                    classNameModifier="vertical-table"
                    theme='without-border'
                    className={`VerticalTable_input ${isPrint ? 'notesPrintsize' : '' }`}
                    name={id}
                    value={column[heading.key]}
                    viewMode={!isEditable}
                    tooltip={heading.tooltip}
                    handleParentChange={this.handleChange}
                    handleInputFocus = {()=>this.handleInputFocus(id)}
                />
            case 'checkbox':
                return <div className="print-control" style={{ display: "flex", justifyContent: "center", gap: "20px", paddingLeft: "50px" }}>
                    <input
                        type="checkbox"
                        name={`${heading.key}-${columnIndex}`}
                        key={`${heading.key}`} disabled={!isEditable}
                        value={column[heading.key]}
                        checked={column[heading.key]} 
                        onClick={e => this.handlePrintKeyClick(e, column, heading)}
                    />
                    {
                        isEditable ? (
                            <select className="custom_select" onChange={(e) => this.handlePrintPagesDropDown(+e.target.value, `print_page_number-${columnIndex}`)} value={column["print_page_number"]}>
                            <option value={1} disabled={printTableColumns.firstPagePrintColumns === 5}>1</option>
                        <option value={2} disabled={printTableColumns.secondPagePrintColumns ===5 || !printTableColumns.firstPagePrintColumns}>2</option>
                        <option value={3} disabled={printTableColumns.thirdPagePrintColumns ===5 || !printTableColumns.secondPagePrintColumns}>3</option>
                        <option value={4} disabled={printTableColumns.fourthPagePrintColumns ===5 || !printTableColumns.thirdPagePrintColumns}>4</option>
                        <option value={5} disabled={printTableColumns.fifthPagePrintColumns ===5 || !printTableColumns.fourthPagePrintColumns}>5</option>
                            </select>
                        ) : (
                            column["print_page_number"]
                        )
                    }
                </div>
            default:
                return <Input
                    id={id}
                    theme={`without-border ${column[heading.key] ? heading.key:''}`}
                    valueType={heading.format}
                    className='VerticalTable_input'
                    name={id}
                    value={hideAutoPopulateKey ?  ``:column[heading.key]}
                    isDollar={!hideAutoPopulateKey && heading.isDollar}
                    viewMode={!isEditable}
                    decimals={heading.decimals}
                    handleParentChange = {this.handleChange}
                    handleInputFocus = {()=>this.handleInputFocus(id)}
                    tooltip={heading.tooltip}
                    tooltipPosition='custom-down'
                />
        }
    }

    handleInputFocus(id){
        this.setState(
            {   
                activeElementId:id,
            }
        );
    }

    handleKeyDown( event ) {
    event.stopPropagation();
    if(event.key=='Enter'){
        event.preventDefault();
    }
    const activeElementId = this.state.activeElementId.split('-')[1];
    const activeHeadingKey = this.state.activeElementId.split('-')[0];
    const currentColumn = this.verticalTableRef.current.children.namedItem(activeElementId);
    let element = currentColumn.children.namedItem(activeHeadingKey);

    if(this.headingKeys.includes(activeHeadingKey)){
        const value = event.target.value;
        const keydownstart = event.target.selectionStart;
        
        switch (event.key) {
            case "ArrowUp": 
                if(activeHeadingKey !== this.headingKeys[0]){
                    if(this.inputIDs.includes(element.previousElementSibling.id))
                        element.previousElementSibling.children[0].children[0].children[0].focus();
                    else if(this.dropdownIDs.includes(element.previousElementSibling.id))
                        element.previousElementSibling.children[0].children[0].children[0].children[0].children[0].focus();
                    else if(this.textareaIDs.includes(element.previousElementSibling.id))
                        element.previousElementSibling.children[0].children[0].focus();
                }
            break;      
            case 'Enter':
            case "ArrowDown": 
                if(activeHeadingKey !== this.headingKeys[this.headingKeys.length-1]){
                    if(this.inputIDs.includes(element.nextElementSibling.id))
                        element.nextElementSibling.children[0].children[0].children[0].focus();
                    else if(this.dropdownIDs.includes(element.nextElementSibling.id))
                        element.nextElementSibling.children[0].children[0].children[0].children[0].children[0].focus();
                    else if(this.textareaIDs.includes(element.nextElementSibling.id))
                        element.nextElementSibling.children[0].children[0].focus();
                }
            break;  
            case "ArrowRight": 
            if(value.length>keydownstart && keydownstart!=value.length){     
                return
            } 
                if(activeElementId<this.props.columns.length){
                    let nextColumn = currentColumn.nextElementSibling
                    element = nextColumn.children.namedItem(activeHeadingKey);
                    if(this.inputIDs.includes(activeHeadingKey))
                        element.children[0].children[0].children[0].focus();
                    else if(this.dropdownIDs.includes(activeHeadingKey))
                        element.children[0].children[0].children[0].children[0].children[0].focus();
                    else if(this.textareaIDs.includes(activeHeadingKey))
                        element.children[0].children[0].focus();
                }
            break;  

            case "ArrowLeft": 
            if(value.length>=keydownstart && keydownstart!=0){         
                return
            }  
            if(activeElementId>0){
                let nextColumn = currentColumn.previousElementSibling
                element = nextColumn.children.namedItem(activeHeadingKey);
                if(this.inputIDs.includes(activeHeadingKey))
                    element.children[0].children[0].children[0].focus();
                else if(this.dropdownIDs.includes(activeHeadingKey))
                    element.children[0].children[0].children[0].children[0].children[0].focus();
                else if(this.textareaIDs.includes(activeHeadingKey))
                    element.children[0].children[0].focus();
            }
            break;  
            default: break;
        }
    }
    };

    handlePrintKeyClick(event, column, heading) {
        const isChecked = event.target.checked;
        const updatedColumns = this.props.columns.map((col) => {
          if (col === column) {
            return {
              ...col,
              [heading.key]: isChecked, 
            };
          }
          return col;
        });    
        this.props.updateColumns(updatedColumns);

        event.stopPropagation();
        this.handleChange(event.target.name, event.target.checked);
    }

    
    renderPrintHeader(title, isHSC, formatedDate){
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

        return(
            <div className='VerticalTable_head'>
            <div className="VerticalTable_left">
                <h3 className='VerticalTable_h3'>{title}</h3>
            <h3 className="VerticalTable_h4">Loan Quotes</h3>
                <h4 className='VerticalTable_h4'>{formatedDate}</h4>
            </div>
            <div className="VerticalTable_right">
                <img className="VerticalTable_logo" src={arc.path.media + (isHSC ? athcapBlueLogo : striveLogo)} alt=''/>
            </div>
        </div>
        );
    }

    renderPrintTable(headings, columns, printBackground, printTitle, noTables, hscTeamMemberDetail){
        function getPrintColums(pageNumber) {
            return columns.filter(e1 => !!e1.is_printable == true).filter((el) => parseInt(el.print_page_number) === pageNumber)
        }
        const printFirstColumns = columns.filter(e1 => !!e1.is_printable == true).filter((el) => el.print_page_number < 2);
        const printSecondColumns = getPrintColums(2);
        const printThirdColumns = getPrintColums(3);
        const printFourthColumns = getPrintColums(4);
        const printFifthColumns = getPrintColums(5);
        let mutipleColumns = [printFirstColumns]; // first column is default setted initially
        function printMultipleColumns() {
            const columnGroups = [printSecondColumns, printThirdColumns, printFourthColumns, printFifthColumns];

            columnGroups.forEach(group => {
                if (group.length) {
                    mutipleColumns.push(group);
                }
            });
        }
        printMultipleColumns()
        const printableColumbs = mutipleColumns.length > 1 ? mutipleColumns : [printFirstColumns];

        const date = new Date();
        const formatedDate = date.getMonth()+1+'/'+date.getDate()+'/'+date.getFullYear();
        const printableHeadings = headings.filter(obj => obj.key != "is_printable");
        
        return printableColumbs.map((cols, colsIndex) => {
            let printedRows = 0;

            return (
                [...Array(noTables)].map((value, index) => {                   
                    const page = printableHeadings.slice(printedRows, printedRows + printRowsPerPage);
                    printedRows += printRowsPerPage;
                    
                    return(
                        <div className={'print-container'} key={`${colsIndex}-${index}`} style={{backgroundImage: printBackground}}>
                            {this.renderPrintHeader(printTitle, true, formatedDate)}
                            {this.renderTable(page, cols, false, index+1, undefined, true,false)}
                            <p className="disclaimer">{`*Disclaimer - Loan Quotes are as of ${formatedDate}, and subject to change.`}</p>
                            {this.renderPrintFooter(true, true, formatedDate, hscTeamMemberDetail)}
                        </div>
                    );
                })
            )
        });
    }

    renderPrintFooter(isPrint, isHSC = false, formatedDate, hscTeamMemberDetail ) {
        if (!isPrint) {
            return null;
        }
        const teamMember1 = hscTeamMemberDetail != [] ? hscTeamMemberDetail[0] : null;
        return (
            <div className={`print-footer ${isHSC ? 'hsc' : ''}`}>
                <div>
               {teamMember1 && 
               <p className="print-footer_details">
                    {`${teamMember1.EMAIL}` } <br/> {`${teamMember1.TITLE}`}
               </p>
               }
                </div>
                <div>
                    <p className="print-footer_details">
                    {
                        isHSC? (teamMember1 ? (`${teamMember1 ? teamMember1.PHONE_NUMBER:  ''} | ${teamMember1 ? teamMember1.EMAIL:  ''}`):'') : '(469) 844-8880 | strivere.com'
                }             
                <br/>
                athenacapitalre.com
                </p>
                </div>
            </div>
        )
    }

    renderTable(headings, columns, isEditable, printIndex=0, tbodyRef, isPrint=false,selectAllChecked){
        const itemProps = tbodyRef ? { ref: tbodyRef } : {};
        function getPrintableColumnsCount(columns, pageNumber) {
            return columns && Array.isArray(columns) && columns.length 
                ? columns.filter((item) => +item.print_page_number === pageNumber && item.is_printable).length 
                : 0;
        }
        const firstPagePrintColumns = getPrintableColumnsCount(columns, 1);
        const secondPagePrintColumns = getPrintableColumnsCount(columns, 2);
        const thirdPagePrintColumns = getPrintableColumnsCount(columns, 3);
        const fourthPagePrintColumns = getPrintableColumnsCount(columns, 4);
        const fifthPagePrintColumns = getPrintableColumnsCount(columns, 5);
        const printTableColumns = { firstPagePrintColumns, secondPagePrintColumns, thirdPagePrintColumns, fourthPagePrintColumns, fifthPagePrintColumns }
        const headingkey = (heading) =>{
            return printIndex ? heading.key+printIndex : heading.key;
        }
        return(
                <table className="VerticalTable">
                    {isEditable && <thead>
                        
                    </thead> }
                    <tbody {...itemProps}>
                    {
                        headings.map((heading, headingIndex) => (
                            <tr key={`row_${headingIndex}`} id={headingkey(heading)} onKeyDown={(e)=> tbodyRef && this.handleKeyDown(e, headingkey(heading))}>
                                <th key={`th_${headingIndex}`} className="VerticalTable_th">                                   
                                    {heading.name === "Select All/Deselect All" ? (
                                    <label>
                                        <input
                                            type="checkbox"
                                            onChange={this.onSelectAllChange}
                                            checked={this.props.columns.every(col => col.is_printable)}
                                            disabled={!this.props.isEditable}
                                        />
                                        <span style={{ marginLeft: '8px' }}>{heading.name}</span>
                                        
                                    </label>
                                    ) : (
                                    heading.name
                                    )}
                                </th>         
                                {
                                    columns.map((column, columnIndex) => {
                                        return(
                                        <td className="VerticalTable_td" key={`${heading}_${columnIndex}`}>
                                            {
                                                this.renderInputElement({column, heading, isEditable, columnIndex, isPrint,printTableColumns})
                                            }
                                        </td>
                                    )})
                                }
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
        )
    }

    moveCard(dragIndex, hoverIndex) {
        if (!this.props.isEditable) {
          return;
        }
          let updatedColumns = [...this.props.columns];
          const [removedCard] = updatedColumns.splice(dragIndex, 1);
          updatedColumns.splice(hoverIndex, 0, removedCard);
          updatedColumns = updatedColumns.map((val, idx)=>{val.loan_quotes_order = idx; val.loan_quotes_modified = true; return val;});
          this.props.updateColumns(updatedColumns);
    }
    
    renderCustomTable(headings, columns, isEditable, printIndex=0, verticalTableRef, isPrint=false,selectAllChecked){
        function getPrintableColumnsCount(columns, pageNumber) {
            return columns && Array.isArray(columns) && columns.length 
                ? columns.filter((item) => +item.print_page_number === pageNumber && item.is_printable).length 
                : 0;
        }
        const firstPagePrintColumns = getPrintableColumnsCount(columns, 1);
        const secondPagePrintColumns = getPrintableColumnsCount(columns, 2);
        const thirdPagePrintColumns = getPrintableColumnsCount(columns, 3);
        const fourthPagePrintColumns = getPrintableColumnsCount(columns, 4);
        const fifthPagePrintColumns = getPrintableColumnsCount(columns, 5);
        const printTableColumns = { firstPagePrintColumns, secondPagePrintColumns, thirdPagePrintColumns, fourthPagePrintColumns, fifthPagePrintColumns }
        return(
            <DndProvider backend={HTML5Backend}>
                <div className="VerticalTable" style={{ display: 'flex', flexDirection: 'row', marginBottom: '16px', height: '100%'}} ref={verticalTableRef}>
                    {
                        <div className="VerticalTable_headers">
                        {(headings.map((heading, headingIndex) => (
                            <div key={`th_${headingIndex}`} className={`VerticalTable_th ${headingIndex === 0 && 'paddingTop10 borderTopLeftRadius6 stickToTop top0'} ${headingIndex === 1 && 'paddingTop10 borderTopLeftRadius6 stickToTop top40'} ${(headingIndex === 0 && isEditable) && 'height76' } ${headings.length-1===headingIndex && 'borderBottomLeftRadius6'} ${heading.name === 'Notes' && 'height70'} ${heading.name.toLowerCase() === "loan structure" ? "loan_structure" : ''}`} style={{zIndex: '2'}}>
                            {heading.name === "Select All/Deselect All" ? (
                                <label>
                                    <input
                                        type="checkbox"
                                        onChange={this.onSelectAllChange}
                                        checked={this.props.columns.every(col => col.is_printable)}
                                        disabled={!this.props.isEditable}
                                    />
                                    <span style={{ marginLeft: '8px' }}>{heading.name}</span>
                                    
                                </label>
                                ) : (
                                heading.name
                            )}
                            </div>
                        )))}
                        </div>
                    }
                    {
                        columns.map((column, columnIndex)=>(
                            <VerticalTableDragableCard
                                moveCard={this.moveCard}
                                column={column}
                                columnIndex={columnIndex}
                                headings={headings} 
                                isEditable={isEditable}
                                isPrint={isPrint} 
                                printTableColumns={printTableColumns} 
                                handleChangeDropdown={this.handleChangeDropdown} 
                                handleChange={this.handleChange} 
                                handleInputFocus={this.handleInputFocus} 
                                handlePrintKeyClick={this.handlePrintKeyClick} 
                                handlePrintPagesDropDown={this.handlePrintPagesDropDown}
                                handleKeyDown={this.handleKeyDown}
                            />
                        ))
                    }
                </div>
            </DndProvider>
        )
    }

    render() {
        const {headings, columns, isEditable, printTitle, hscTeamMemberDetail, hasPrint = false} = this.props;
        const {printBackground, printHeadings, printTablesNumber} = this.state;
        const { selectAllChecked } = this.state;
        return (
            <div className="VerticalTableMain">   
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>    
                {hasPrint && this.renderPrintTable(printHeadings, columns, printBackground, printTitle, printTablesNumber, hscTeamMemberDetail)}
                <div className="renderTable">
                        {/* {this.renderTable(headings, columns, isEditable, 0, this.tbodyRef,selectAllChecked)} */}
                        {this.renderCustomTable(headings, columns, isEditable, 0, this.verticalTableRef,selectAllChecked)}

                        {/* add new column button */}
                        <div className={`add-new-button ${!isEditable&&'add-new-button-card-disabled'}`} onClick={(e)=>{if(isEditable)this.props.addNewColumn(e)}} style={{minWidth:'200px'}}>
                            <div className={`button-new plus ${isEditable?'positive': 'add-new-button-disabled'}`}>
                                <Icon svg={plus}/>
                            </div>
                        </div>
                </div>
            </div>
        );
    }
}

VerticalTable.propTypes = {
    isEditable: PropTypes.bool,
    headings: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    hasPrint: PropTypes.bool,
    printTitle: PropTypes.string,
    hscTeamMemberDetail: PropTypes.array,
    handleChangeInput: PropTypes.func,
    handleChangeDropdown: PropTypes.func,
    handlePrintPagesDropDown: PropTypes.func,
    updateColumns: PropTypes.func.isRequired,
};